// @flow
import * as R from "ramda"

const minIn = (list: ?Array<?number>): ?number => {
  if (list === undefined || list === null || list.length === 0) {
    return undefined
  }

  return R.compose(
    R.reduce((acc, item) => R.min(item, acc), undefined),
    R.reject(R.isNil),
  )(list)
}

export default minIn
